import { createContext } from 'react';
import { TrackerClientRequest } from '../event/eventConstants';
import { TBuildTarget, TProductKey, TRobloxEnvironment, TTargetEnvironment } from '../types';
import { defaultNavigationDrawerState, NavigationDrawerState } from './useNavigationDrawerState';

export type NavigationConfigsContextValue = NavigationDrawerState & {
  environment: TTargetEnvironment;
  robloxEnvironment: TRobloxEnvironment;
  target: TBuildTarget;
  currentProduct: TProductKey;
  enableAssistant: boolean;
  disableProducts: string[] | null;
  creatorEventsVariant: string | null;
  drawerVariant: 'fullScreen' | 'belowAppBar';
  sendEvent: (clientRequest: TrackerClientRequest) => void;
  navigationDropdownTabs: TProductKey[] | null;
  enableCourses: boolean;
  enableNotificationTrayV2: boolean; // TODO @neoxu(10/23/2025): Remove this once the notification tray v2 is fully released
  enableReverseDelegation: boolean;
  enableReverseDelegationShadow: boolean;
  isCompact: boolean;
};
const defaultContextValue: NavigationConfigsContextValue = {
  environment: 'production',
  robloxEnvironment: 'production',
  target: 'global',
  currentProduct: 'CreatorHub',
  enableAssistant: false,
  disableProducts: null,
  creatorEventsVariant: null,
  drawerVariant: 'fullScreen',
  navigationDropdownTabs: null,
  enableCourses: false,
  enableNotificationTrayV2: false, // TODO @neoxu(10/23/2025): Remove this once the notification tray v2 is fully released
  enableReverseDelegation: false,
  enableReverseDelegationShadow: false,
  isCompact: false,
  ...defaultNavigationDrawerState,
  sendEvent: () => {
    throw new Error('Not implemented');
  },
};

const NavigationConfigsContext = createContext<NavigationConfigsContextValue>(defaultContextValue);
NavigationConfigsContext.displayName = 'NavigationConfigsContext';

export default NavigationConfigsContext;
